import { TablePaginationConfig } from 'ant-design-vue/lib/table';
import { reactive } from 'vue';

export function pagination() {
  return reactive<TablePaginationConfig>({
    showQuickJumper: true,
    showSizeChanger: true,
    pageSize: 10,
    current: 1,
    total: 0,
    pageSizeOptions: ['5', '10', '20', '50'],
    hideOnSinglePage: false,
  });
}
export function tablePage(calBack?: () => void, rowKeyStr = '', other = '') {
  const data = pagination();
  return {
    rowKey(row: any) {
      const temp = row[other] || other;
      const userStr = rowKeyStr ? row[rowKeyStr] + temp : '';
      const str = userStr || row.id || row.key;
      return str;
    },
    params<T>(param: T = {} as T) {
      // 过滤掉空值
      const newParam = Object.fromEntries(
        Object.entries(param as Record<string, any>).filter(
          ([_, value]) => value !== '' && value !== null,
        ),
      );
      return Object.assign(
        { pageIndex: data.current! as number, pageSize: data.pageSize! as number },
        newParam,
      );
    },
    pagination: data,
    pageChange(p: typeof data) {
      data.current = p.current;
      data.pageSize = p.pageSize;
      if (calBack) {
        calBack();
      }
    },
  };
}
export type PageType = ReturnType<typeof tablePage>;
